// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiGrid-root.upload-mainContainer{
        background-color: #292B49;
        padding: 20px;
        width: 100%;
    /* height: calc(100vh - 95px); */
}

.MuiBox-root.upload-container{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
}
.MuiBox-root.upload-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 10px 0px;
}
.MuiBox-root.upload-image-card{
    height: 226px;
}
.MuiBox-root.generate-button{
    display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: 2px dashed #aaa;
  border-radius: 16px;
}
.MuiTypography-root.uploadTexts{
        color: #EEEEF2;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
    text-transform: none;
    margin: 10px 0px;
}
.MuiBox-root.uploadButton{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}
.MuiBox-root.uploadButton .styledButton{
    height: 55px;
}
.MuiFormControl-root .MuiInputBase-root .MuiSelect-select{
    min-height: 2.3rem;
    padding-top: 10px;
    padding-bottom: 0px;
}
.MuiFormControl-root.voiceSelector .MuiInputBase-root .MuiSelect-select{
  min-height: 2.3rem;
  padding-top: 0px;
  padding-bottom: 0px;
}
.MuiBox-root.audioControls{
    display: flex;
    gap: 10px;
    justify-content: space-between;
}
.MuiBox-root.flex-scroll-area {
  flex-grow: 1;
  padding-left: 16px;
  padding-right: 16px;
  overflow-y: auto;
  height: calc(100dvh - 55px);
}
.animatedTextOverlay{
position: absolute;
  top: 0;
  left: 33%;
  width: auto;
  height: 100%;
  aspect-ratio: 9 / 16;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  padding: 0;
  text-align: center;
  color: #fff;
  text-shadow: 0 2px 8px #000, 0 0 2px #000;
  font-size: 20px;
  opacity: 0.9;
  font-weight: 700;
  word-break: break-word;
  line-height: 1.2;
  font-family: serif;
  background: transparent;
}
.MuiBox-root.formControl{
    display: flex;
    gap: 20px;
    width: 100%;
}
.MuiBox-root.reelsButton{
    display: flex;
    justify-content: flex-end;
}

@media screen and (max-width: 1024px){
.css-1sos3zc-MuiStack-root>:not(style)~:not(style){
    margin-left: 0px !important;
}
.MuiBox-root.flex-scroll-area {
  overflow-y: auto;
  height: 100%;
}

}
@media screen and (min-width: 768px){
    .formControl>.MuiFormControl-root.duration{
    width: 30%;
}
}
@media screen and (min-width: 1024px){
    .rampwalk-uploaded-images>.MuiBox-root>.my-masonry-grids {
    height: calc(100dvh - 40rem);
    overflow-y: auto;
    min-height: 280px;
}
    .rampwalk-uploaded-images>.MuiBox-root>.uploaded-images-grid{
        height: calc(100dvh - 40rem);
        overflow-y: auto;
        min-height: 450px;
    }
    .MuiGrid-root.upload-mainContainer{
        min-height: 800px;
    }
  
}`, "",{"version":3,"sources":["webpack://./src/components/Rampwalk/Rampwalk.css"],"names":[],"mappings":"AAAA;QACQ,yBAAyB;QACzB,aAAa;QACb,WAAW;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,SAAS;AACb;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;QACQ,cAAc;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;AACA,kBAAkB;EAChB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;AACA;IACI,2BAA2B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;AACA;IACI;IACA,UAAU;AACd;AACA;AACA;IACI;IACA,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;IACI;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;;AAEJ","sourcesContent":[".MuiGrid-root.upload-mainContainer{\n        background-color: #292B49;\n        padding: 20px;\n        width: 100%;\n    /* height: calc(100vh - 95px); */\n}\n\n.MuiBox-root.upload-container{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    gap: 20px;\n}\n.MuiBox-root.upload-header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin: 10px 0px;\n}\n.MuiBox-root.upload-image-card{\n    height: 226px;\n}\n.MuiBox-root.generate-button{\n    display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  border: 2px dashed #aaa;\n  border-radius: 16px;\n}\n.MuiTypography-root.uploadTexts{\n        color: #EEEEF2;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n    text-transform: none;\n    margin: 10px 0px;\n}\n.MuiBox-root.uploadButton{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n.MuiBox-root.uploadButton .styledButton{\n    height: 55px;\n}\n.MuiFormControl-root .MuiInputBase-root .MuiSelect-select{\n    min-height: 2.3rem;\n    padding-top: 10px;\n    padding-bottom: 0px;\n}\n.MuiFormControl-root.voiceSelector .MuiInputBase-root .MuiSelect-select{\n  min-height: 2.3rem;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n.MuiBox-root.audioControls{\n    display: flex;\n    gap: 10px;\n    justify-content: space-between;\n}\n.MuiBox-root.flex-scroll-area {\n  flex-grow: 1;\n  padding-left: 16px;\n  padding-right: 16px;\n  overflow-y: auto;\n  height: calc(100dvh - 55px);\n}\n.animatedTextOverlay{\nposition: absolute;\n  top: 0;\n  left: 33%;\n  width: auto;\n  height: 100%;\n  aspect-ratio: 9 / 16;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 2;\n  padding: 0;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 2px 8px #000, 0 0 2px #000;\n  font-size: 20px;\n  opacity: 0.9;\n  font-weight: 700;\n  word-break: break-word;\n  line-height: 1.2;\n  font-family: serif;\n  background: transparent;\n}\n.MuiBox-root.formControl{\n    display: flex;\n    gap: 20px;\n    width: 100%;\n}\n.MuiBox-root.reelsButton{\n    display: flex;\n    justify-content: flex-end;\n}\n\n@media screen and (max-width: 1024px){\n.css-1sos3zc-MuiStack-root>:not(style)~:not(style){\n    margin-left: 0px !important;\n}\n.MuiBox-root.flex-scroll-area {\n  overflow-y: auto;\n  height: 100%;\n}\n\n}\n@media screen and (min-width: 768px){\n    .formControl>.MuiFormControl-root.duration{\n    width: 30%;\n}\n}\n@media screen and (min-width: 1024px){\n    .rampwalk-uploaded-images>.MuiBox-root>.my-masonry-grids {\n    height: calc(100dvh - 40rem);\n    overflow-y: auto;\n    min-height: 280px;\n}\n    .rampwalk-uploaded-images>.MuiBox-root>.uploaded-images-grid{\n        height: calc(100dvh - 40rem);\n        overflow-y: auto;\n        min-height: 450px;\n    }\n    .MuiGrid-root.upload-mainContainer{\n        min-height: 800px;\n    }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
